module.exports = __webpack_public_path__ + "img/delivery.572a2b5.jpg";